import { Injectable } from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { CookiesLogin, LogoutUser } from '.././auth/login/actions/login.actions';
import {Router} from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private route: Router,
                private store: Store<AppState>) { }

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return next.handle(request).pipe(catchError(err => {
    //         if (err.status === 401) {
    //             this.store.dispatch(LogoutUser());
    //             this.route.navigate(['/']);
    //         }
    //
    //         // return throwError("");
    //     }))
    // }

  private publicRoutes = ['/', '/car-market', '/uae', '/ga', '/naor', '/home', '/about', '/faq', '/contact', '/terms', '/car-market-coll', '/car-overview', '/AccesabilityStatement'];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {}, (error: any) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          const currentUrl = this.route.url.split('?')[0];
          const isPublic = this.publicRoutes.some(r => currentUrl === r || currentUrl.startsWith(r + '/'));
          if (!isPublic) {
            this.route.navigate(['/']);
          }
          console.log(error);
        }
      })
    );
  }
}
